import {HTMLProps} from "react";
import {Icon} from "@/components/atoms/icons";

interface Props extends HTMLProps<HTMLDivElement> {
  icon: any,
  title: string,
  description: string
}

export const Edito = ({icon, title, description, children, ...rest}: Props) => {

  return <div  {...rest}>
    <div className="p-2 text-center">
      <div className={"flex items-center justify-center"}>
        <Icon image={icon} className={"h-28 w-28"}/>
      </div>
      <p className="text-xl pb-2 font-medium">{title}</p>
      <p className="text-base pb-2 text-justify">{description}</p>
      <div className={'flex justify-center items-center'}>
        <div>{children}</div>
      </div>
    </div>
  </div>
}